/*global internalMessageClientData, stAdmin, HtmlTemplateManager, moment, st, animateCss, root, io, stt */
/*eslint no-console: ["error", { allow: ["warn", "error", "debug", "log"] }] */

var internalMessageClient;
$(document).ready(function () {
    internalMessageClient = new InternalMessageClient();
});

/**
 * Internal message client
 *
 * emit prefix: IM
 */
function InternalMessageClient()
{
    if(inIframe() || typeof internalMessageClientData === 'undefined') return;

    var userData = internalMessageClientData.userData;
    var nodeServer = internalMessageClientData.nodeServer;
    var nodePath = internalMessageClientData.nodePath;
    var defLang = internalMessageClientData.deflang;
    var isAdminPage = internalMessageClientData.isAdminPage;
    var webpageWebmoduls = internalMessageClientData.webpageWebmoduls;
    var internalMessagesWebpage = internalMessageClientData.internaMessagesWebpage;
    var webpageTitle = internalMessageClientData.webpageTitle;

    var modulsOnPage = [];
    var namespace = "/notifications";
    var socket;
    var adminDataTable;
    var templateManager;
    var notificationContainer = ".modul-internalmessages .notifications-container";
    var usermenuBlinker;

    var newMessageAnimation = "shake";
    var oldMessageAnimation = "fadeIn";
    var usermenuBlinkTime = 10; //sec
    var notificationShowUpTime = 5; // sec
    var loadedMessageIds = [];

    this.sendReadStatus = sendReadStatus;
    this.setAdminDataTable = setAdminDataTable;
    this.notify = notify;

    connect();

    $(document).bind("internalMessageClient-templatesLoaded", function () {
        getAllMessages();
    });

    /**
     * Listen to connection
     */
    socket.on('connect', function(){
        sendClientInfo(function(){
            getUnSendedMessages()
            initTemplates()
        })
    });

    /**
     * Listen to all messages emit
     */
    socket.on('IM_allMessages', function (datas) {
        $(".modul-internalmessages .loader-screen").fadeOut(function () {
            $(notificationContainer).fadeIn(function () {
                checkMessages(datas.messages);
                appendMessageToPage(datas.messages);
            });
        });
    });

    /**
     * Listen to all unread messages
     */
    socket.on('IM_allUnReadMessages', function (datas) {
        updateUserMenu(datas.unReadAmount);
    });

    /**
     * Listen to all sended messages
     */
    socket.on('IM_allUnSendedMessages', function (datas) {
        if(datas.unSendedAmount>0){
            notify({title: stAdmin.IM_YOU_HAVE_UNREAD_MESSAGES});
            var ids = datas.ids.split(",");
            $.each(ids, function(i, id){
                sendRecievedStatus({status:0, id:id});
            });
        }
        getUnReadMessages();
    });

    /**
     * Listen to user received message
     */
    socket.on('IM_userReceivedMessage', function (data) {
        updateAdminTableCell(data.messageId, "received", data.summeryAmount);
    });

    /**
     * Listen to user read message
     */
    socket.on('IM_userReadMessage', function (data) {
        updateAdminTableCell(data.messageId, "read", data.summeryAmount);
    });

    /**
     * Listen to new messages
     */
    socket.on('IM_getNewMessages', function (data)
    {
        checkMessages(data.message);
        appendMessageToPage([data.message], true);
        if(data.message.broadcast){
            getUnReadMessages();
        } else {
            updateUserMenu(data.unReadAmount);
        }
        notify(data.message);
    });

    /**
     * Listen read message
     */
    socket.on('IM_setMessageToRead', function (data)
    {
       if(modulOnPage("webmodul_internalmessages")){
           $("#notification-"+data.messageId+"-"+userData.id).removeClass("non-read").addClass("read");
       }
    });

    /**
     * This function get all messages
     */
    function getAllMessages()
    {
        if(modulOnPage("webmodul_internalmessages") && !$.isEmptyObject(userData)){
            socket.emit('IM_getAllMessages');
        }
    }

    /**
     * This function init the tempaltes for the internalmessages modul
     */
    function initTemplates()
    {
        if (modulOnPage("webmodul_internalmessages"))
        {
            templateManager = new HtmlTemplateManager({
                customLoader: true,
                eventPrefix: "internalMessageClient"
            });

            var templates = [
                { folder: "notification", template: "notification-main" },
                { folder: "notification", template: "related-course-label", htmlEncode: false }
            ];

            templateManager.loadTemplates(templates);
        }
    }

    /**
     * This function append the message elements to the page
     * @param {array} messages
     * @param {boolean} newMessage
     */
    function appendMessageToPage(messages, newMessage)
    {
        if(typeof newMessage === "undefined"){
            newMessage = false;
        }

        if (modulOnPage("webmodul_internalmessages") && !$.isEmptyObject(userData))
        {
            $.each(messages, function (i, message)
            {
                if(existMessage(message.id)){
                    return
                } else {
                    loadedMessageIds.push(message.id)
                }
                var sendDatetime = moment(message.insertdate);
                var actualuntilDatetime = moment(message.actualuntil);
                var relatedCourses = getRelatedCourses(message.relatedcourses);
                var status;
                if((message.status == 0 || message.status == 1 || message.status == null) && message.isactual==1){
                    status = "non-read actual";
                } else if((message.status == 0 || message.status == 1 || message.status == null) && message.isactual==0) {
                    status = "non-read non-actual";
                } else if(message.status == 2 && message.isactual==1) {
                    status = "read actual";
                } else if(message.status == 2 && message.isactual==0){
                    status = "read non-actual";
                }

                var replacedata =
                {
                    STATUS: status,
                    TITLE: message.title,
                    DATE: sendDatetime.format("YYYY.MM.DD"),
                    TIME: sendDatetime.format("HH:mm"),
                    MESSAGE: message.message,
                    ID: "notification-" + message.id + "-" + userData.id,
                    RELATEDCOURSES: "",
                    ACTUALDATETEXT: message.actualuntil ? st.IM_ACTUAL : "",
                    ACTUALDATE: message.actualuntil ? actualuntilDatetime.format("YYYY.MM.DD HH:mm") : ""
                };

                $(notificationContainer).prepend(templateManager.getElement("notification-main", replacedata));

                var element = notificationContainer+" #notification-" + message.id + "-" + userData.id;
                if (relatedCourses.length) {
                    $(element + " .related-course-cell").append(relatedCourses);
                }

                var animation = newMessage && message.isactual ? newMessageAnimation : oldMessageAnimation;
                animateCss(element, animation);

                sendRecievedStatus(message);
            });
        }
    }

    /**
     * Check the message is loaded to the page
     * @param {int} paramId
     */
    function existMessage(paramId)
    {
        return loadedMessageIds.find(function(id){
            return paramId == id
        })
    }

    /**
     * This function update the user menu internal messages badges
     * @param {int} unReadAmount
     */
    function updateUserMenu(unReadAmount)
    {
        if (modulOnPage("webmodul_loginpanel") && !$.isEmptyObject(userData))
        {
            $("#mynotifications .badge").html(unReadAmount);
            if(unReadAmount>0){
                $("#mynotifications .badge").addClass("have-unreaded");
                animateCss("#mynotifications .badge", "bounceIn");
                if(!usermenuBlinker){
                    usermenuBlinker = setInterval(function(){
                        animateCss("#mynotifications .badge", "rubberBand");
                    }, usermenuBlinkTime*1000);
                }
            } else {
                clearInterval(usermenuBlinker);
                $("#mynotifications .badge").removeClass("have-unreaded");
            }
        }

        // New design user menu tab
        var $wmim = $('.webmenus_internalmessages');
        $('.mainmenu-item-desktop-tab')
        .toggleClass('mainmenu-item-desktop-tab-notify', !!(unReadAmount && $wmim.length));
        $wmim.find('.usermenu-counter-highlight')
        .text(unReadAmount ? unReadAmount + ' ' + stt('USERMENU_NOTIFICATION_NEW') : '')
        .toggleClass('hide', !unReadAmount);

        setPageTitle(unReadAmount);
    }

    /**
     * Set the webpage title
     * @param {int} unReadAmount
     */
    function setPageTitle(unReadAmount)
    {
        if(modulOnPage("webmodul_internalmessages"))
        {
            if(unReadAmount>0){
                document.title = "("+unReadAmount+") "+webpageTitle;
            } else {
                document.title = webpageTitle;
            }
        }
    }

    /**
     * This function get the unread messages
     */
    function getUnReadMessages(){
        socket.emit('IM_getUnReadMessages');
    }

    /**
     * This function get the unread messages
     */
    function getUnSendedMessages(){
        if(!$.isEmptyObject(userData)){
            socket.emit('IM_getUnSendedMessages');
        }
    }

    /**
     * This function check the messages. If no messages display the No messages message.
     * @param {array | object} messages
     */
    function checkMessages(messages)
    {
        if (messages.length == 0) {
            $(".modul-internalmessages #no-notification").fadeIn("fast");
        } else {
            $(".modul-internalmessages #no-notification").fadeOut("fast");
        }
    }

    /**
     * Send client info to node server
     */
    function sendClientInfo(callBack) {
        socket.emit('IM_clientInfo', {
            userData: userData,
            defLang: defLang,
            moduls: modulsOnPage,
            isAdminPage: isAdminPage
        }, callBack);
    }

    /**
     * This function emit to node server the user got it the message
     * @param {object} message
     */
    function sendRecievedStatus(message) {
        if ((message.status == 0 || message.status == null) && message.id) {
            socket.emit('IM_receivedStatus', {
                messageId: message.id
            });
        }

    }

    /**
     * This function emit to node server the user read it the message
     * @param {int} messageId
     */
    function sendReadStatus(messageId) {
        socket.emit('IM_readStatus', {
            messageId: messageId
        });
    }

    /**
     * This function get the related courses to the message
     * @param {string} relatedCourses
     */
    function getRelatedCourses(relatedCourses) {
        var courses = relatedCourses ? relatedCourses.split("@@@") : [];
        var linkdata = [];
        $.each(courses, function (i, course) {
            var coursesData = course.split("###");
            var link = coursesData[0];
            var title = coursesData[1];
            var href = '<a href="' + link + '" target="_blank">' + title + '</a>';
            linkdata.push(templateManager.getElement("related-course-label", { LINK: href, LEVEL: "" }));
        });
        return linkdata;
    }

    /**
     * This function update the admin datatable cells
     * @param {int} rowId
     * @param {string} cell (received, read, sended)
     * @param {int} value
     */
    function updateAdminTableCell(rowId, cell, value) {
        if (typeof adminDataTable !== "undefined") {
            var row = adminDataTable.row('#row_' + rowId);
            var sended = row.cell(".sended").data();
            if (parseInt(value) === parseInt(sended)) {
                var stIndex;
                if (cell == "received") {
                    stIndex = "IMS_ALL_USER_GOT_IT";
                } else if(cell == "read"){
                    stIndex = "IMS_ALL_USER_HAVE_READ";
                }
                var filter = '<a id="clickadvancedsearch" onclick="advancedsearch(\'' + stIndex + '\',\'' + cell + '\',\'FILTER_EQUALS\')" title=' + stAdmin.FILTERING + '><span class="fa fa-filter"></span> </a>';

                value = filter + " " + stAdmin[stIndex];
            }
            var cellElement = $(row.node()).find('td.' + cell);
            cellElement.html(value);
            cellElement.eq(0).addClass('highlight');
            setTimeout(function(){
                cellElement.eq(0).removeClass('highlight');
            }, 300);
        }
    }

    /**
     * This function set the admin datatable
     * @param {object} table
     */
    function setAdminDataTable(table) {
        adminDataTable = table;
    }

    /**
     * This function check if the modul is on the page
     * @param {string} modul
     */
    function modulOnPage(modul)
    {
        if( modulsOnPage.indexOf(modul) !== -1){
            return true;
        } else {
            return false;
        }
    }

    /**
     * This function fired the notify plugin
     * @param {object} message
     */
    function notify(message)
    {
        if (!modulOnPage("webmodul_internalmessages"))
        {
            var icon = '<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 40"><title>harang_ikon</title><path class="bell-icon" d="M27.61,25.23s-.27-1.58-.62-3.34S24.62,10.1,24.62,10.1a5.73,5.73,0,0,0-2.95-2.72V5.45a4.17,4.17,0,0,0-8.34,0v1.9a5.73,5.73,0,0,0-2.94,2.72s-2,10-2.37,11.79-.62,3.34-.62,3.34L3.26,29.81v2.46H31.74V29.81Zm-10-18.65h-.18a11.5,11.5,0,0,0-1.62.12V5.5a1.71,1.71,0,0,1,3.42,0V6.7A11.5,11.5,0,0,0,17.59,6.58ZM13.15,34.82h0a4.15,4.15,0,0,0,4.35,3.79,4.15,4.15,0,0,0,4.35-3.79h0V33.59h-8.7Z" /></svg>';

            var options =
            {
                message: message.title,
                url: root+internalMessagesWebpage.url,
                target: '_blank'
            };
            var settings =
            {
                placement: {
                    from: "bottom",
                    align: "left"
                },
                newest_on_top: true,
                mouse_over: "pause",
                counter: "circle",
                delay: notificationShowUpTime*1000,
                animate: {
                    enter: "animated bounceInLeft",
                    exit: "animated bounceOutLeft"
                },
                template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="alert">' +
                    '<button type="button" aria-hidden="true" class="close" data-notify="dismiss">×</button>' +
                    '<span data-notify="icon">'+icon+'</span> ' +
                    '<span data-notify="title">{1}</span> ' +
                    '<span data-notify="message">{2}</span>' +
                    '<div class="counter" data-notify="counter">' +
                    '</div>' +
                    '<div class="circle" data-notify="circle">' +
                    '</div>' +
                    '<a href="{3}" target="{4}" data-notify="url"></a>' +
                    '</div>'
            };

            $.notify(options, settings);

            sendRecievedStatus(message);
        }
    }

    /**
     * Connect to the node server
     */
    function connect() {
        if (webpageWebmoduls && webpageWebmoduls.length) {
            $.each(webpageWebmoduls, function (i, modul) {
                modulsOnPage.push(modul.systemmodulname);
            });
        }

        socket = io.connect(nodeServer + namespace, { path: nodePath });
    }

    /**
     * Check if page in iframe
     */
    function inIframe () {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

}